var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"page-container"},[_c('div',{staticClass:"login-with-twitch",on:{"click":_vm.login}},[_c('i',{staticClass:"fab fa-twitch"}),_vm._v("Connection Twitch ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }